export const SET_SPIN = 'SET_SPIN';
export const SET_NIGHT = 'SET_NIGHT';
export const SET_FIXED = 'SET_FIXED';